import { render, staticRenderFns } from "./Util-Item-Listrik.vue?vue&type=template&id=9a0e32e2"
import script from "./Util-Item-Listrik.vue?vue&type=script&lang=js"
export * from "./Util-Item-Listrik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports